export const QUOTE_REFRESH_INTERVAL_MS = 30_000;
